/**
 * Module tile icons from core API are stroke-only SVG data URLs (safe to mask).
 * Tenant-uploaded / CDN SVGs often include fills and must render as <img>.
 */
export function shouldRenderTileIconAsImage(url: string): boolean {
  const trimmed = url.trim();
  if (!trimmed) return false;
  const lower = trimmed.toLowerCase();
  if (lower.startsWith('http://') || lower.startsWith('https://')) {
    return true;
  }
  if (lower.includes('.svg') && !lower.startsWith('data:image/svg+xml')) {
    return true;
  }
  return false;
}
